import { render, staticRenderFns } from "./EventContestEntryFormStep1.vue?vue&type=template&id=dbbdade6&scoped=true"
import script from "./EventContestEntryFormStep1.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventContestEntryFormStep1.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventContestEntryFormStep1.vue?vue&type=style&index=0&id=dbbdade6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbdade6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbbdade6')) {
      api.createRecord('dbbdade6', component.options)
    } else {
      api.reload('dbbdade6', component.options)
    }
    module.hot.accept("./EventContestEntryFormStep1.vue?vue&type=template&id=dbbdade6&scoped=true", function () {
      api.rerender('dbbdade6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/EventContestEntryFormStep1.vue"
export default component.exports